module.exports = __webpack_public_path__ + "img/10.85f5bd71.jpg";